// Vite exposes `import.meta.env.PROD` at build-time for reliable prod detection.
const isProduction = import.meta.env.PROD;

// api
export const apiHost = import.meta.env.VITE_API_HOST || "localhost";
export const apiPort = import.meta.env.VITE_API_PORT || "8089";
export const apiUrl = isProduction
  ? `https://${apiHost}`
  : `http://${apiHost}:${apiPort}`;
